<template>
  <a-modal
    wrap-class-name="report-reject-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :title="title"
    cancelText="再看看"
    okText="确认驳回"
    @cancel="$emit('onCancel')"
    @ok="$emit('onSubmit')"
  >
    <div class="report-reject-reason">
      <a-icon type="close-circle" class="icofont" />正在驳回报告
    </div>
    <a-form :form="form">
      <a-form-item
        :colon="false"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 15 }"
        label="驳回原因"
      >
        <a-input
          v-decorator="[
            'verify_desc',
            {
              rules: [{ required: true, message: '请输入原因' }],
            },
          ]"
          placeholder="请输入原因"
        />
      </a-form-item>
    </a-form>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </a-modal>
</template>

<script>
export default {
  props: ["title", "visible", "data", "btnIsLoading"],
  data() {
    return {
      form: this.$form.createForm(this),
      previewVisible: false,
      previewImage: "",
    };
  },
  mounted() {},
  methods: {
    // 多图片预览
    handlePreview(img) {
      this.previewVisible = true;
      this.previewImage = img;
    },
    // 单张图片预览
    handlePreviewSingle(url) {
      this.previewVisible = true;
      this.previewImage = url;
    },
    // 关闭预览
    handleCancel() {
      this.previewVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.report-reject-modal-wrapper {
  .report-reject-row {
    padding: 0 50px;
  }
  .report-reject-label {
    padding: 15px 0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(195, 199, 213, 1);
  }
  .report-reject-value {
    padding: 15px 0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
  }
  .report-reject-reason {
    margin: 10px 0;
    color: rgba(0, 0, 0, 0.65);
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
  }
}
.icofont {
  color: #f5222d;
  font-size: 22px;
  margin-right: 5px;
  float: left;
}
</style>
